import React, { useState } from 'react';
import { maskNascimento } from '../../../Auxiliar/Masks';
import { MdAdd, MdDelete } from 'react-icons/md';
import DefaultButton from '../../ReusableComponents/DefaultButton';
import PortalButton from './PortalButton';
import PortalFieldHelp from './PortalFieldHelp';

export default function ScheduleEditor({ schedule = [] }) {
  const [rows, setRows] = useState(schedule);
  const change = (index, key, value) =>
    setRows((all) =>
      all.map((row, position) => (position === index ? { ...row, [key]: value } : row))
    );
  return (
    <section className="portal-form-section portal-schedule-editor">
      <div className="portal-admin-row">
        <div>
          <h3>
            Cronograma
            <PortalFieldHelp label="Cronograma">
              Etapas informativas da seleção. As datas não alteram automaticamente os prazos de
              inscrição ou de acesso à prova.
            </PortalFieldHelp>
          </h3>
          <p>Adicione a data e a descrição de cada etapa.</p>
        </div>
        <DefaultButton
          text="Adicionar etapa"
          bg="confirm"
          icon={<MdAdd />}
          onClick={() => setRows((all) => [...all, { date: '', title: '' }])}
        />
      </div>
      <input type="hidden" name="schedule" value={JSON.stringify(rows)} readOnly />
      {!rows.length && <p className="form-text">Nenhuma etapa adicionada.</p>}
      {rows.map((row, index) => (
        <div className="portal-schedule-row" key={index}>
          <label className="form-label">
            <span>Data da etapa {index + 1}</span>
            <input
              className="form-control"
              placeholder="dd/mm/aaaa"
              inputMode="numeric"
              maxLength={10}
              pattern="[0-9]{2}/[0-9]{2}/[0-9]{4}"
              required
              value={row.date}
              onChange={(event) =>
                change(index, 'date', maskNascimento(event.target.value.replace(/\D/g, '')))
              }
            />
          </label>
          <label className="form-label">
            <span>Descrição da etapa {index + 1}</span>
            <input
              className="form-control"
              maxLength={255}
              required
              value={row.title}
              onChange={(event) => change(index, 'title', event.target.value)}
            />
          </label>
          <div className="portal-schedule-action">
            <PortalButton
              title={`Remover etapa ${index + 1}`}
              aria-label={`Remover etapa ${index + 1}`}
              className="btn btn-sm btn-danger"
              onClick={() => setRows((all) => all.filter((_, position) => position !== index))}
            >
              <MdDelete />
            </PortalButton>
          </div>
        </div>
      ))}
    </section>
  );
}
